<template>
  <div class="vh-100 p-4 bg-dark">
    <div class="d-flex justify-content-center align-items-center">
      <img src="@/assets/logo/logo.png" alt="App Logo" class="mb-4" />
    </div>

    <b-button @click="triggerCleanSync" variant="danger" size="sm" class="mt-2">
      Clean Sync
    </b-button>

    <b-button @click="triggerCreateSync" :disabled="isSyncing" variant="primary" class="mb-4">
      {{ isSyncing ? "Syncing..." : "Sync" }}
    </b-button>

    <div class="mt-5 pt-3 px-3 pb-3 bg-light border rounded">
      <h6 class="text-uppercase font-poppins">
        Sync History
        <em>({{ itemsSorted.length }} items)</em>
      </h6>

      <div v-for="item in itemsSorted" :key="item.createdAt" class="mt-3 pt-3 border-top">
        <strong>{{ item.type }} - {{ item.country }}</strong>
        <b-badge :variant="getStatusVariant(item.status)" class="ml-2" pill>{{ item.status }}</b-badge>
        <br />
        <em>Created at: {{ formatDate(item.createdAt) }}</em>
        <br />
        <span>Done items: {{ item.numberOfItemsProcessed }}</span>
        <span>Total items: {{ item.numberOfItemsTotal }}</span>
        <b-progress :value="item.numberOfItemsProcessed" :max="item.numberOfItemsTotal" class="mt-2">
          <b-progress-bar :value="item.numberOfItemsProcessed" :max="item.numberOfItemsTotal">
            {{ calculateProgressPercentage(item) }}%
          </b-progress-bar>
        </b-progress>

        <b-button @click="triggerContinueSync(item.id)" variant="warning" size="sm" class="mt-2">
          Continue Sync
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { BButton, BBadge, BProgress, BProgressBar } from "bootstrap-vue";

import { CREATE, FETCH, LISTEN, CONTINUE, CLEAN } from "@/store/actions";

export default {
  name: "AdminDashboard",
  components: {
    BButton,
    BBadge,
    BProgress,
    BProgressBar,
  },
  data: () => ({
    isSyncing: false,
  }),
  computed: {
    ...mapGetters("adminSync", ["itemsSorted"]),
  },
  mounted() {
    this.triggerFetchSyncs();
    this.triggerListenSyncs();
  },
  methods: {
    ...mapActions("adminSync", {
      fetchSyncs: FETCH,
      listenSyncs: LISTEN,
      createSync: CREATE,
      continueSync: CONTINUE,
      cleanSync: CLEAN,
    }),
    async triggerFetchSyncs() {
      await this.fetchSyncs();
    },
    triggerListenSyncs() {
      this.listenSyncs();
    },

    async triggerCreateSync() {
      await this.createSync();
    },

    formatDate(timestamp) {
      return new Date(timestamp).toLocaleString();
    },
    getStatusVariant(status) {
      switch (status) {
        case "in-progress":
          return "warning";
        case "completed":
          return "success";
        default:
          return "secondary";
      }
    },
    calculateProgressPercentage(item) {
      if (item.numberOfItemsTotal === 0) return 0;
      return Math.round((item.numberOfItemsProcessed / item.numberOfItemsTotal) * 100);
    },
    async triggerContinueSync(syncId) {
      await this.continueSync({ syncId });
    },
    async triggerCleanSync() {
      await this.cleanSync();
    },
  },
};
</script>
